import React from 'react';
import { Flame, Wrench, GraduationCap, Settings, ClipboardCheck, RotateCw } from 'lucide-react';
import { services } from '../data/mockData';
import { Button } from './ui/button';

const iconMap = {
  flame: Flame,
  wrench: Wrench,
  graduationCap: GraduationCap,
  settings: Settings,
  clipboardCheck: ClipboardCheck,
  rotateCw: RotateCw
};

const Services = () => {
  const phoneNumber = '573184476101';
  const whatsappMessage = 'Hola, Quisiera tener información acerca de ...';

  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider bg-orange-100 px-4 py-2 rounded-full">
              Nuestros Servicios
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Soluciones Integrales de
            <span className="text-orange-600"> Seguridad</span>
          </h2>
          <p className="text-lg text-gray-600">
            Ofrecemos servicios completos de protección contra incendios con personal
            certificado y equipos de última generación.
          </p>
        </div>

        {/* Grid de servicios */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <button
                key={service.id}
                type="button"
                onClick={openWhatsApp}
                className="group bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-orange-500 hover:shadow-xl transition-all duration-300 text-left w-full"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Icon */}
                <div className="bg-orange-100 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:bg-orange-600 transition-colors">
                  <IconComponent
                    className="text-orange-600 group-hover:text-white transition-colors"
                    size={32}
                  />
                </div>

                {/* Contenido */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Indicador hover */}
                <div className="mt-6 flex items-center text-orange-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-sm">Más información</span>
                  <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </button>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            ¿Necesitas un servicio personalizado?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Nuestro equipo de expertos puede diseñar una solución específica para tu empresa o proyecto.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={openWhatsApp}
              size="lg"
              className="bg-orange-600 hover:bg-orange-700 text-white px-8"
            >
              Solicitar Asesoría
            </Button>
            <Button
              onClick={() => scrollToSection('productos')}
              size="lg"
              variant="outline"
              className="border-2 border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white px-8"
            >
              Ver Productos
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;